import Section from '@/Types/Section';
import PagingInfo from '@/Types/PagingInfo';
import Page from '@/Types/Page';

export default class PaginationService {
    private readonly sections: Section[];
    private readonly currentPage: Page;
    private readonly currentSection: Section;
    private readonly currentSectionIx: number;

    constructor(sections: Section[], currentSection: string, currentPage: Page) {
        this.sections = sections;
        const currentSectionIx = this.getCurrentSectionIx(currentSection)

        if (currentSectionIx === undefined) {
            throw new Error('Could not resolve current section')
        }

        this.currentSectionIx = currentSectionIx;
        this.currentSection = this.sections[currentSectionIx];

        this.currentPage = currentPage;
    }

    public getPrev(): PagingInfo | null {
        try {
            const section = this.isFirstPage() ? this.getPrevSection() : this.currentSection;
            const pageNum = this.isFirstPage() ? section.page_count : this.currentPage.number - 1;

            return {
                section: section.name,
                pageNum
            };
        } catch (e) {
            return null;
        }
    }

    public getNext(): PagingInfo | null {
        try {
            const section = this.isLastPage() ? this.getNextSection() : this.currentSection;
            const pageNum = this.isLastPage() ? 1 : this.currentPage.number + 1;

            return {
                section: section.name,
                pageNum
            };
        } catch (e) {
            return null;
        }
    }

    private getCurrentSectionIx(currentSection: string): number | undefined {
        return this.sections.findIndex(({name}) => name === currentSection);
    }

    private isFirstPage(): boolean {
        return this.currentPage.number === 1
    }

    private isLastPage(): boolean {
        return this.currentPage.number === this.currentSection.page_count;
    }

    private getPrevSection(): Section {
        if (this.currentSectionIx > 0) {
            return this.sections[this.currentSectionIx - 1];
        }

        throw new Error('No previous section found');
    }

    private getNextSection(): Section {
        if (this.currentSectionIx < this.sections.length) {
            return this.sections[this.currentSectionIx + 1];
        }

        throw new Error('No next section found');
    }

}
